var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_3287)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.777 11.9916C24.777 5.36871 19.3239 0 12.5974 0V4.4888C16.8061 4.4888 20.2181 7.84796 20.2181 11.9916H24.7774H24.777Z",
    fill: "#e6e02a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5806 22.1356C29.9782 20.0889 33.4793 13.324 31.4005 7.02539L27.0642 8.41246C28.3649 12.3533 26.1742 16.5858 22.1714 17.8664L23.5803 22.1356H23.5806Z",
    fill: "#e6e02a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4116 24.1499C17.3656 29.5076 24.9825 30.6956 30.4244 26.8028L27.7446 23.1712C24.3398 25.6067 19.5742 24.8634 17.1003 21.5112L13.4116 24.1495V24.1499Z",
    fill: "#e6e02a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.32389 15.2505C4.36996 20.6082 5.57628 28.1073 11.0185 32L13.6983 28.3684C10.2934 25.9328 9.53842 21.2409 12.0122 17.8888L8.32352 15.2505H8.32389Z",
    fill: "#e6e02a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3476 7.73626C8.95006 5.68999 2.0788 9.13693 0 15.4351L4.33627 16.8222C5.63697 12.8813 9.93594 10.7249 13.9387 12.0051L15.3476 7.7359V7.73626Z",
    fill: "#e6e02a"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_3287"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.f5bac86dfe1683eba80c5e4daa5973af.svg";
export { ForwardRef as ReactComponent };